"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useYesNo = exports.DialogValues = exports.useDecisionDialog = exports.DecisionDialog = void 0;
var react_1 = __importDefault(require("react"));
var morse_react_1 = require("morse-react");
var Dialog_1 = require("./Dialog");
var DecisionDialog = function (props) {
    var choices = props.choices, onChosen = props.onChosen, allowDismiss = props.allowDismiss, valueOnDismiss = props.valueOnDismiss, onDismissed = props.onDismissed, dialogProps = __rest(props, ["choices", "onChosen", "allowDismiss", "valueOnDismiss", "onDismissed"]);
    var buttons = choices.map(function (choice) {
        var _a;
        return (react_1.default.createElement(morse_react_1.Button, __assign({ key: dialogProps.title + "-" + choice.value, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = onChosen;
                            if (!_a) return [3 /*break*/, 2];
                            return [4 /*yield*/, onChosen(choice.value)];
                        case 1:
                            _a = (_b.sent());
                            _b.label = 2;
                        case 2:
                            _a;
                            return [2 /*return*/];
                    }
                });
            }); } }, choice.buttonProps), (_a = choice.text) !== null && _a !== void 0 ? _a : choice.value));
    });
    return (react_1.default.createElement(Dialog_1.Dialog, __assign({}, dialogProps, { buttons: buttons, allowDismiss: allowDismiss, onDismissed: function () {
            onChosen && onChosen(valueOnDismiss);
            onDismissed && onDismissed();
        } })));
};
exports.DecisionDialog = DecisionDialog;
var useDecisionDialog = function (dialogDetails) {
    var dialogBroker = Dialog_1.useDialog();
    return {
        show: function () {
            return new Promise(function (resolve) {
                dialogBroker.show(react_1.default.createElement(exports.DecisionDialog, { className: dialogDetails.className, key: morse_react_1.PortalManager.getPortalCount(), title: dialogDetails.title, icon: dialogDetails.icon, onChosen: function (value) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!dialogDetails.onChosen) return [3 /*break*/, 2];
                                    return [4 /*yield*/, dialogDetails.onChosen(value)];
                                case 1:
                                    _a.sent();
                                    _a.label = 2;
                                case 2:
                                    resolve(value);
                                    dialogBroker.close();
                                    return [2 /*return*/];
                            }
                        });
                    }); }, choices: dialogDetails.choices }, dialogDetails.message));
            });
        },
        close: function () {
            if (dialogBroker) {
                dialogBroker.close();
            }
        },
    };
};
exports.useDecisionDialog = useDecisionDialog;
var DialogValues;
(function (DialogValues) {
    DialogValues["Yes"] = "Yes";
    DialogValues["No"] = "No";
    DialogValues["Ok"] = "OK";
    DialogValues["Cancel"] = "Cancel";
    DialogValues["Continue"] = "Continue";
})(DialogValues = exports.DialogValues || (exports.DialogValues = {}));
var useYesNo = function (yesNoDetails) {
    var yesButtonText = yesNoDetails.yesButtonText, noButtonText = yesNoDetails.noButtonText, yesButtonProps = yesNoDetails.yesButtonProps, noButtonProps = yesNoDetails.noButtonProps, rest = __rest(yesNoDetails, ["yesButtonText", "noButtonText", "yesButtonProps", "noButtonProps"]);
    var details = __assign(__assign({}, rest), { choices: [
            {
                value: DialogValues.Yes,
                text: yesButtonText !== null && yesButtonText !== void 0 ? yesButtonText : DialogValues.Yes,
                buttonProps: yesButtonProps,
            },
            {
                value: DialogValues.No,
                text: noButtonText !== null && noButtonText !== void 0 ? noButtonText : DialogValues.No,
                buttonProps: noButtonProps,
            },
        ] });
    return exports.useDecisionDialog(details);
};
exports.useYesNo = useYesNo;
//# sourceMappingURL=DecisionDialog.js.map